/**
 * Lista de Fundos Listados
 * - Mostra/oculta a tabela ao trocar o tipo de fundo no filtro
 *   (responde ao evento 'nossos-fundos-filter:change' com filter === 'tipo')
 * - Copy ticker: copia o código na área de transferência ao clicar no ícone
 */
export function initListaFundosListados() {
  const wrapper = document.querySelector('.lista-fundos--listados');
  if (!wrapper) return;

  // ── Bleed direito no mobile ───────────────────
  // Cancela o padding-right do .container para a tabela chegar até a borda.
  function applyMobileBleed() {
    const table = wrapper.querySelector('.lista-fundos__table');
    if (!table) return;
    const container = wrapper.closest('.container');
    if (!container) return;
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      const pr = parseFloat(getComputedStyle(container).paddingRight) || 0;
      table.style.marginRight = `-${pr}px`;
    } else {
      table.style.marginRight = '';
    }
  }
  applyMobileBleed();
  window.addEventListener('resize', applyMobileBleed);

  // Visibilidade controlada pelo global.js (coordena tipo + visualizacao)

  // ── Copy ticker ───────────────────────────────
  wrapper.querySelectorAll('.lista-fundos__ticker-copy').forEach(btn => {
    btn.addEventListener('click', async () => {
      const ticker = btn.dataset.ticker;
      if (!ticker) return;

      await navigator.clipboard.writeText(ticker);

      const copyIcon  = btn.querySelector('.lista-fundos__copy-icon');
      const checkIcon = btn.querySelector('.lista-fundos__check-icon');
      if (copyIcon)  copyIcon.style.display  = 'none';
      if (checkIcon) checkIcon.style.display = 'inline-flex';
      setTimeout(() => {
        if (copyIcon)  copyIcon.style.display  = '';
        if (checkIcon) checkIcon.style.display = 'none';
      }, 1500);
    });
  });
}
